import { PageHeader } from '@/components/ui';
import { useI18n } from '@/i18n';
import { WindowCard } from './WindowCard';
import { ExcelImportCard } from './ExcelImportCard';
import { AltasMasivasCard } from './AltasMasivasCard';
import { LegalRequests } from './LegalRequests';
import { Orphans } from './Orphans';
import { AuditLog } from './AuditLog';

export function AdminScreen() {
  const { lang, t } = useI18n();
  return (
    <div className="screen-enter" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <PageHeader
        title={t('admin.title')}
        sub={lang === 'es' ? 'Control central — solo Admin ETC' : 'Central control — ETC Admin only'}
      />
      <WindowCard />
      <ExcelImportCard />
      <AltasMasivasCard />
      <LegalRequests />
      <Orphans />
      <AuditLog />
    </div>
  );
}
